export default __webpack_public_path__ + "static/media/sun.23b34846.svg";